<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'History Bimbingan: ' + title" @back="back">
            <template slot="tags">
                <a-tag 
                    color="green"
                    v-if="items.files.length > 0 && items.files[items.files.length - 1].approved_level == 2 &&
                        items.files[items.files.length - 1].response_time != null"
                >Sudah Disetujui</a-tag>
            </template>
            <common-training-header :withUser="true" :user_hash="attendant" />
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.files"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="counter" slot-scope="text, record, index">
                    {{ index+1 }}
                </div>  

                <div slot="file" slot-scope="record">
                    <a-space>
                        <a-tooltip title="Download File">
                            <a-button type="link" size="small" @click="download(record.file_path)">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                        </a-tooltip>
                    </a-space>
                </div>

                <div slot="upload_at" slot-scope="record">
                    <div v-if="record.created_at != null">
                        {{ moment(record.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="file_response" slot-scope="record">
                    <a-button type="link" size="small" @click="download(record.response_file)" v-if="record.response_file != null">
                        <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                    </a-button>
                </div>

                <div slot="koreksi" slot-scope="record">
                    <div v-if="record.response_time != null">
                        {{ moment(record.response_time).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="approved_at" slot-scope="record">
                    <div v-if="record.approved_time1 != null">
                        {{ moment(record.approved_time1).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="remark" slot-scope="record">
                    <a-tooltip title="Catatan">
                        <a-button
                            v-if="record.remark != null && record.remark != 'null'"
                            size="small"
                            icon="profile"
                            @click="showRemark(record.remark)"
                        />
                    </a-tooltip>
                </div>

                <div slot="action" slot-scope="text, record, index" class="text-center">
                    <a-space size="large">
                        <a-tooltip title="Koreksi">
                            <div v-if="index == (items.files.length-1)">
                                <div v-if="isAdvisor">
                                    <a-button
                                        v-if="record.approved_level == 1"
                                        size="small"
                                        type="primary"
                                        icon="edit"
                                        @click="showModal(false, record.id, record.remark, record.response_file)"
                                    />
                                </div>
                            </div>
                        </a-tooltip>
                        <a-tooltip title="Approve">
                            <div v-if="isAdvisor">
                                <a-button
                                    type="primary" icon="check"
                                    size="small"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="showConfirm"
                                    v-if="index == (items.files.length-1) && items.files.length >= 1 && items.files[items.files.length - 1].approved_level == 1 &&
                                        items.files[items.files.length - 1].response_time == null"/>
                            </div>
                            <div v-else>
                                <a-button
                                    type="primary" icon="check"
                                    size="small"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="showConfirm"
                                    v-if="index == (items.files.length-1) && items.files.length >= 1 && items.files[items.files.length - 1].approved_level == 0 &&
                                        items.files[items.files.length - 1].response_time_mentor == null"/>
                            </div>
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>

        <a-modal
            :visible="visible"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <a-card type="inner" size="small">
                <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                    <a-divider dashed orientation="left">Koreksi</a-divider>
                    <div v-if="role != 'mentor'">
                        <div v-if="response_file != null">
                            File Koreksi: <a-button type="link" size="small" @click="download(response_file)">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                            <a-form-item>
                                <a-upload
                                    :file-list="fileList"
                                    :remove="handleRemove"
                                    :before-upload="beforeUpload"
                                    @change="handleChange"
                                >
                                    <a-button>
                                        <a-icon type="upload" /> Reupload
                                    </a-button>
                                </a-upload>
                            </a-form-item>
                        </div>
                        <a-form-item label="File Koreksi" v-else>
                            <a-upload
                                :file-list="fileList"
                                :remove="handleRemove"
                                :before-upload="beforeUpload"
                                @change="handleChange"
                            >
                                <a-button>
                                    <a-icon type="upload" /> Select File
                                </a-button>
                            </a-upload>
                        </a-form-item>
                    </div>
                    <a-form-item label="Catatan">
                        <a-textarea 
                            v-decorator="['remark']"
                            :rows="4" />
                    </a-form-item>
                    <a-form-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                        >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-modal>

        <a-modal
            :visible="visibleRemark"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <a-card type="inner" size="small">
                {{ remark }}
                <a-row type="flex" justify="center" align="top" style="margin-top: 12px">
                    <a-col>
                        <a-button
                            @click="handleClose"
                            >Tutup</a-button>
                    </a-col>
                </a-row>
            </a-card>
        </a-modal>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'counter',
            title: 'Bimbingan Ke',
            align: 'center',
            scopedSlots: {customRender: 'counter'},
        }, {
            key: 'file',
            title: 'File',
            align: 'center',
            scopedSlots: {customRender: 'file'}
        }, {
            key: 'upload_at',
            title: 'Tanggal Upload',
            align: 'center',
            scopedSlots: {customRender: 'upload_at'}
        }, {
            key: 'file_response',
            title: 'File Koreksi',
            align: 'center',
            scopedSlots: {customRender: 'file_response'}
        }, {
            key: 'koreksi',
            title: 'Tanggal Koreksi',
            align: 'center',
            scopedSlots: {customRender: 'koreksi'}
        }, {
            key: 'approved_at',
            title: 'Tanggal Validasi',
            align: 'center',
            scopedSlots: {customRender: 'approved_at'}
        }, {
            key: 'remark',
            title: 'Catatan',
            align: 'center',
            scopedSlots: {customRender: 'remark'}
        }, {
            key: 'action',
            title: 'Action',
            align: 'center',
            scopedSlots: {customRender: 'action'}
        }, 
    ]

    export default {
        props: {
            outline: {
                type: String,
                required: true
            },
            hash: {
                type: String,
                required: true
            },
            attendant: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                columns,
                items: {
                    outline: {
                        title: '',
                        hash: ''
                    },
                    activity: {},
                    files: []
                },
                loading: false,
                visible: false,
                visibleRemark: false,
                reupload: false,
                processing: false,
                file: null,
                response_file: null,
                fileList: [],
                formLayout: 'horizontal',
                form: this.$form.createForm(this),
                formData: {},
                remark: ''
            }
        },
        created() {
            this.getItems()
        },
        computed: {
            title() {
                switch(this.outline) {
                    case 'project_evaluation':
                        return 'Evaluasi Project'
                    case 'proposal':
                        return 'Proposal'
                    case 'evaluation':
                        return 'Evaluasi Kinerja'
                    default: 
                        return this.items.outline.title
                }
            },
            activeModule() {
                return this.$laravel.active_module
            },
            role(){
                return this.$laravel.roles[this.activeModule.module.identifier]
            },
            isAdvisor(){
                return this.role == 'advisor'
            },
            isMentor() {
                return this.role == 'mentor'
            }
        },
        methods: {
            getItems() {
                this.loading = true;
                this.$http
                    .get(this.routeUri("api.activity-files.files", { outline: this.hash }), {
                        params: {
                            attendant: this.attendant
                        }
                    })
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            showModal(reupload = false, file_id = null, remark = null, response_file = null) {
                this.reupload = reupload
                this.file = file_id
                this.response_file = response_file
                
                if(remark != null){
                    this.form.getFieldDecorator("remark", { initialValue: remark });
                }

                this.visible = true;
            },
            showRemark(remark){
                this.visibleRemark = true
                this.remark = remark

            },
            handleClose(isRefresh) {
                this.visible = false;
                this.visibleRemark = false;

                this.fileList = []
                this.formData = {}

                if (isRefresh == true) {
                    this.getItems();
                }
            },
            approving(){
                this.processing = true;

                let promise;

                var data = new FormData();

                data.append("is_approved", 1);

                promise = this.$http.post(
                    this.routeUri("api.activity-files.response", {
                        file: this.items.files[this.items.files.length - 1].id
                    }),
                    data
                );

                promise
                    .then(response =>
                        this.handleSuccessResponse(response.data)
                    )
                    .catch(error =>
                        this.handleResponseError(error.response.data)
                    )
                    .finally(() => (this.processing = false));
            },
            handleSubmit(e) {
                e.preventDefault(e);

                this.form.validateFields((err, formData) => {
                    if (!err) {
                        this.processing = true;

                        let promise;

                        var data = new FormData();

                        if(formData.remark == undefined)
                            formData.remark = ''

                        if(this.role == 'mentor'){
                            formData.remark_mentor = formData.remark
                            formData.remark = null
                        }

                        for (var k in formData) {
                            if (formData.hasOwnProperty(k)) {
                                data.append(k, formData[k]);
                            }
                        }

                        if(this.fileList.length > 0){
                            data.append("with_file", 1);
                            data.append("attachment", this.fileList[0]);
                        }else{
                            data.append("with_file", 0);
                        }

                        promise = this.$http.post(
                            this.routeUri("api.activity-files.response", {
                                file: this.file
                            }),
                            data
                        );

                        promise
                            .then(response =>
                                this.handleSuccessResponse(response.data)
                            )
                            .catch(error =>
                                this.handleResponseError(error.response.data)
                            )
                            .finally(() => (this.processing = false));
                    }
                });
            },
            handleSuccessResponse(data) {
                var successMessage = "Data berhasil diproses!";

                if (typeof data.successMessage != "undefined") {
                    successMessage = data.successMessage;
                }

                this.$notification.success({
                    message: "Sukses!",
                    description: successMessage
                });
                setTimeout(() => this.handleClose(true), 500);
            },
            handleResponseError(data) {
                if (data.hasOwnProperty("errors")) {
                    for (let key in data.errors) {
                        this.$notification.error({
                            message: "Gagal proses " + key,
                            description: Object.values(data.errors[key])
                        });
                    }
                } else {
                    this.$notification.error({
                        message: "Gagal proses",
                        description: "Data tidak dapat diproses."
                    });
                }
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();

                newFileList.splice(index, 1);

                this.fileList = newFileList;
            },
            beforeUpload(file) {
                this.fileList = [...this.fileList, file];

                return false;
            },
            handleChange(info) {
                let fileList = [...info.fileList];

                if (fileList.length > 1) {
                    fileList = fileList.slice(-1);

                    fileList = fileList.map(file => {
                        if (file.response) {
                            file.url = file.response.url;
                        }
                        return file;
                    });
                    this.fileList = fileList;
                }
            },
            download(url) {
                window.open(window.location.origin + url, '_blank')
            },
            showConfirm() {
                var msg = 'Anda yakin akan melakukan approve?'

                this.$confirm({
                    title: 'Konfirmasi',
                    content: msg,
                    onOk: () => {
                        this.approving()
                    },
                    onCancel() {},
                    class: 'test',
                });
            },
            back() {
                let params = {
                    outline: this.outline,
                    hash: this.hash
                }

                if(this.outline == 'paper'){
                    window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.paper.attendants') + '?' + this.$qs.stringify(params)
                }else{
                    window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.' + this.outline + '.attendants') + '?' + this.$qs.stringify(params)
                }
            },
            isDisplaying(approved_level){
                switch(this.role){
                    case "mentor": {
                        return approved_level >=1
                    }
                    default: return true
                }
            }
        }
    }
</script>